import React, { useRef, useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "../styles/cartVerificationDashboardStyles.scss";
import {
  TextField,
  InputAdornment,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import FontIcon from "react-md/lib/FontIcons";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import Button from "react-md/lib/Buttons/Button";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import ColumnFilterPopover from "../../../../../components/common/ColumnFilterPopover/ColumnFilterPopover";
import CartDashboardUtils from "../services/CartDashboardUtils";
import Helper from "util/Helper";
import RefreshButton from "../../navigo-module/helper/RefreshButton";
import { DialogContainer } from "react-md";
import { formatCurrency } from "../../navigo-module/helper/formatCurrency";
import InfoButton from "../../account-module/helper/InfoButton";
import intToTime from "../../navigo-module/helper/intToTime";
import {
  MODES,
  SERVICE_TYPE,
} from "../../navigo-module/helper/appointmentConstants";
import {
  UserTypeFilter,
  getProfileIconColor,
  getProfileLabel,
} from "../../navigo-module/components/UserTypeFilter";
import {
  CART_STATUS_PENDING_REVIEW,
  CART_STATUS_ON_HOLD,
  CART_STATUS_REJECTED,
  CART_STATUS_SUCCESS,
  CART_STATUS_PENDING_TOPUP,
  CART_STATUS_CANCELLED,
} from "../constants/cart-constants";
import MarkOnHoldDialog from "./PrescribedDiagnosticsComponents/MarkOnHoldDialog";
import RejectOrderDialog from "./PrescribedDiagnosticsComponents/RejectOrderDialog";
import CartRejectedDialog from "./PrescribedDiagnosticsComponents/CartRejectedDialog";

function CartVerificationDashboard(props) {
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [componentMounted, setComponentMounted] = useState(false);
  const cartDashboardUtils = new CartDashboardUtils();
  const helper = new Helper();
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [filterObj, setFilterObj] = useState({
    pageNum: 1,
    pageSize: 30,
  });
  const [onlyPageChange, setOnlyPageChange] = useState(false);
  const [noAppointments, setNoAppointments] = useState(true);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [numFrom, setNumFrom] = useState(0);
  const [numTo, setNumTo] = useState(0);
  const [creationDateFrom, setCreationDateFrom] = useState(null);
  const [creationDateTo, setCreationDateTo] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openFilter, setOpenFilter] = useState(0);
  const [maxDate, setMaxDate] = useState("");
  const skip = useRef(30);
  const [createdByFilterValue, setCreatedByFilterValue] = useState([]);
  const [statusFilterValue, setStatusFilterValue] = useState([]);
  const [removeFilters, setRemoveFilters] = useState(false);
  const [patientIdFilterText, setPatientIdFilterText] = useState("");
  const [aptIdFilterText, setAptIdFilterText] = useState("");
  const [cartIdFilterText, setCartIdFilterText] = useState("");
  const [reqApptDateFrom, setReqApptDateFrom] = useState(null);
  const [reqApptDateTo, setReqApptDateTo] = useState(null);
  // Every health-checkup provider, fetched once on mount — the Service provider
  // name column labels rows from it (the filter popover pages its own list).
  const [serviceProviderNameOptions, setServiceProviderNameOptions] = useState(
    [],
  );
  const providersById = useMemo(
    () => new Map(serviceProviderNameOptions.map((p) => [p.id, p])),
    [serviceProviderNameOptions],
  );
  // The applied provider filter: [{ id, label }], read as included or excluded
  // per serviceProviderFilterMode (the popover's Invert).
  const [
    filterServiceProviderNameOptions,
    setFilterServiceProviderNameOptions,
  ] = useState([]);
  const [serviceProviderFilterMode, setServiceProviderFilterMode] =
    useState("include");
  const serviceProviderFilterIconRef = useRef(null);
  // Cart bookings only ever use these two service modes, so the "Requested
  // service mode" filter is a fixed two-option list rather than fetched.
  const [modesOptions] = useState([MODES.HOME_SAMPLE, MODES.CENTRE_VISIT]);
  const [filterModesOptions, setFilterModesOptions] = useState([]);
  const [razorPayDetails, setRazorPayDetails] = useState(null);
  const [refundFailedDetails, setRefundFailedDetails] = useState(null);
  const [refundReasonDetails, setRefundReasonDetails] = useState(null);
  // Row-level status action menu — rendered via MUI Menu so the popup mounts
  // in a portal at <body> root and escapes the row's :hover line-clamp expansion
  // (otherwise the row grows on hover and the inline-anchored menu jitters as
  // it follows the row's changing height). Mirrors NavigoDashboard's Select.
  const [statusMenuAnchor, setStatusMenuAnchor] = useState(null);
  const [statusMenuCart, setStatusMenuCart] = useState(null);
  // CartId for which the MarkOnHoldDialog is open (launched from the dropdown).
  const [holdDialogForCart, setHoldDialogForCart] = useState(null);
  // CartId for which the RejectOrderDialog is open (launched from the dropdown).
  const [rejectDialogForCart, setRejectDialogForCart] = useState(null);
  // CartId currently being resumed via POST /resume (used to disable the row
  // dropdown so a double-click can't fire two requests).
  const [resumingCartId, setResumingCartId] = useState(null);
  // Cart row whose Rejected status pill was clicked — opens a read-only
  // dialog showing the stored reject reason + description.
  const [rejectedCartForDialog, setRejectedCartForDialog] = useState(null);
  // id → label maps for the two reason catalogs, used by the On hold /
  // Rejected pills' hover hint. null until fetched. The ids are per-catalog
  // and unrelated, so a hold id must never be resolved against the reject map.
  const [holdReasonsById, setHoldReasonsById] = useState(null);
  const [rejectReasonsById, setRejectReasonsById] = useState(null);

  const allStatusList = [
    {
      value: CART_STATUS_PENDING_REVIEW,
      name: "Pending review",
      colorLight: "#FFF9E3",
      colorDark: "#FFBC2E",
    },
    {
      value: CART_STATUS_ON_HOLD,
      name: "On hold",
      colorLight: "#FFF9E3",
      colorDark: "#FFBC2E",
    },
    {
      value: CART_STATUS_PENDING_TOPUP,
      name: "Payment pending",
      colorLight: "#E3F2FD",
      colorDark: "#1565C0",
    },
    {
      value: CART_STATUS_REJECTED,
      name: "Rejected",
      colorLight: "#FBDFD9",
      colorDark: "#E54336",
    },
    {
      value: CART_STATUS_SUCCESS,
      name: "Successful",
      colorLight: "#CBECDE",
      colorDark: "#0A5033",
    },
    {
      value: CART_STATUS_CANCELLED,
      name: "Cancelled",
      colorLight: "#EAEAEA",
      colorDark: "#616161",
    },
  ];

  const allCreatedByList = [
    { value: 1, name: "Patient" },
    { value: 2, name: "Employee" },
    { value: 3, name: "System generated" },
    { value: 4, name: "Expert" },
    { value: 5, name: "Service provider" },
  ];

  const getButtonStyle = (color) => {
    const base = {
      cursor: "pointer",
      marginLeft: "10px",
      minWidth: "125px",
      textTransform: "none",
      fontSize: "medium",
      borderRadius: "5px",
      color: "#FFFFFF",
    };

    switch (color) {
      case "zyOrange":
        return { ...base, backgroundColor: "#F77F11" };
      case "zyGreen":
        return { ...base, backgroundColor: "#04C9D3" };
      case "zyDisabled":
        return { ...base, backgroundColor: "#C2C2C2" };
      default:
        return { ...base, backgroundColor: "#EBEBEB", color: "#333333" };
    }
  };

  useEffect(() => {
    handleGetAllCarts();
    handleFetchServiceProviderNameOpt("");
    handleFetchReasonCatalogs();
    setComponentMounted(true);
  }, []);

  useEffect(() => {
    if (componentMounted && onlyPageChange == true) {
      setFilterObj({ ...filterObj, pageNum: pageNum });
    }
  }, [onlyPageChange]);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  useEffect(() => {
    if (componentMounted) {
      skip.current = 30;
      handleGetAllCarts();
    }
  }, [filterObj]);

  const handleGetAllCarts = (type = 1, btnType = 0) => {
    setLoading(true);

    const payload = {
      pageNum: filterObj.pageNum || 1,
      pageSize: filterObj.pageSize || 30,
      // Carts needing action first: Pending review → On hold → Payment pending →
      // the rest, newest first within each (cart-service; opt-in, Bridge only).
      statusOrderSort: true,
    };
    if (filterObj.cartId) {
      payload.cartId = filterObj.cartId;
    }
    if (filterObj.appointmentId) {
      payload.appointmentId = filterObj.appointmentId;
    }
    if (filterObj.patientId) {
      payload.patientId = filterObj.patientId;
    }
    if (
      Array.isArray(filterObj.serviceProviderIds) &&
      filterObj.serviceProviderIds.length > 0
    ) {
      payload.serviceProviderIds = filterObj.serviceProviderIds;
    }
    if (
      Array.isArray(filterObj.ignoreServiceProviderIds) &&
      filterObj.ignoreServiceProviderIds.length > 0
    ) {
      payload.ignoreServiceProviderIds = filterObj.ignoreServiceProviderIds;
    }
    if (
      filterObj.requestedAppointmentDate &&
      (filterObj.requestedAppointmentDate.from ||
        filterObj.requestedAppointmentDate.to)
    ) {
      payload.requestedAppointmentDate = filterObj.requestedAppointmentDate;
    }
    // The "Creation date" filter — a range over the cart's pendingVerificationAt.
    if (
      filterObj.pendingVerificationAt &&
      (filterObj.pendingVerificationAt.from ||
        filterObj.pendingVerificationAt.to)
    ) {
      payload.pendingVerificationAt = filterObj.pendingVerificationAt;
    }
    if (Array.isArray(filterObj.status) && filterObj.status.length > 0) {
      payload.status = filterObj.status;
    }
    if (Array.isArray(filterObj.mode) && filterObj.mode.length > 0) {
      payload.mode = filterObj.mode;
    }
    if (
      Array.isArray(filterObj.profileTypes) &&
      filterObj.profileTypes.length > 0
    ) {
      payload.profileTypes = filterObj.profileTypes;
    }

    cartDashboardUtils.fetchCartsByFilter(
      payload,
      (res) => {
        setOnlyPageChange(false);
        if (res && res.carts && res.carts.length > 0) {
          const allList = res.carts.map((cart) => ({ ...cart }));
          let localNumFrom, localNumTo;
          if (type === 1) {
            localNumFrom = 1;
            localNumTo = Math.min(30, res.count);
          } else if (type === 2) {
            if (btnType === 0) {
              localNumTo = numFrom - 1;
              localNumFrom = Math.max(numFrom - 30, 1);
            } else {
              localNumFrom = numTo + 1;
              localNumTo = Math.min(numTo + 30, res.count);
            }
          } else if (type === 3) {
            localNumFrom = numFrom;
            localNumTo = numTo;
          }
          setAppointmentsList([...allList]);
          setNoAppointments(false);
          setNumFrom(localNumFrom);
          setNumTo(localNumTo);
          setTotalCount(res.totalCount);
          setLoading(false);
        } else {
          setAppointmentsList([]);
          setNoAppointments(true);
          setLoading(false);
        }
        setRemoveFilters(false);
      },
      (err) => {
        setLoading(false);
        setAppointmentsList([]);
        setNoAppointments(true);
        setRemoveFilters(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  // A provider's details live under the block for its service type.
  const providerInfo = (p) =>
    p?.checkupInfo ||
    p?.consultationInfo ||
    p?.dentalInfo ||
    p?.vaccineInfo ||
    p?.gymInfo;

  // Filter option label, as on the appointments dashboard: "(id) name - city - landmark".
  const formatProviderLabel = (p) => {
    const info = providerInfo(p);
    return [
      `(${p?.id}) ${info?.identityDetails?.name || ""}`.trim(),
      info?.address?.city,
      info?.address?.landmark,
    ]
      .filter(Boolean)
      .join(" - ");
  };

  // Row cell, as on the appointments dashboard: "(id) name (city - landmark)".
  // Just "(id)" until the provider list loads (or for a provider not in it).
  const formatProviderCell = (providerId) => {
    if (!providerId) return "—";
    const info = providerInfo(providersById.get(providerId));
    const name = info?.identityDetails?.name;
    const place = [info?.address?.city, info?.address?.landmark]
      .filter(Boolean)
      .join(" - ");
    return [`(${providerId})`, name, place && `(${place})`]
      .filter(Boolean)
      .join(" ");
  };

  // Pages health-checkup providers into the filter popover. searchByNameOrId
  // (not the appointments dashboard's name-only search) so an id finds its
  // provider too; the term is a server-side regex, so escape it.
  const loadServiceProviderOptions = (q, offset, limit) =>
    new Promise((resolve) => {
      cartDashboardUtils.fetchServiceProvidersByFilter(
        {
          pageNum: Math.floor(offset / limit) + 1,
          pageSize: limit,
          serviceTypeIds: [SERVICE_TYPE.HEALTH_CHECKUP],
          searchByNameOrId: (q || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        },
        (res) => {
          const providers = (res && res.providers) || [];
          const total =
            typeof res?.totalCount === "number"
              ? res.totalCount
              : offset + providers.length;
          resolve({
            options: providers.map((p) => ({
              id: p.id,
              label: formatProviderLabel(p),
            })),
            total,
            hasMore: offset + providers.length < total,
          });
        },
        () => resolve({ options: [], total: 0, hasMore: false }),
      );
    });

  // Both reason catalogs, fetched once on mount and kept as id → label maps for
  // the On hold / Rejected pills' hover hint.
  //
  // includeInactive: a cart holds the id it was actioned under, and ops may have
  // retired that entry since — the active-only list would blank the label on
  // exactly the historical rows the hint exists to explain.
  //
  // Failures stay silent: the hint degrades to the raw description and an
  // error toast over a decoration would only bury real list errors.
  const handleFetchReasonCatalogs = () => {
    const toLabelMap = (res) =>
      (Array.isArray(res) ? res : []).reduce((map, r) => {
        map[r.id] = r.label;
        return map;
      }, {});

    cartDashboardUtils.fetchHoldReasons(
      true,
      (res) => setHoldReasonsById(toLabelMap(res)),
      () => setHoldReasonsById({}),
    );
    cartDashboardUtils.fetchRejectReasons(
      true,
      (res) => setRejectReasonsById(toLabelMap(res)),
      () => setRejectReasonsById({}),
    );
  };

  // Hover-hint body for an On hold / Rejected row: the catalog reason label the
  // cart was actioned under plus the reviewer's free text. Returns null for any
  // other status, and for rows carrying neither (older carts predating the
  // reason catalogs), so those pills keep a plain no-tooltip hover.
  const renderStatusReasonHint = (cart) => {
    const isOnHold = cart?.status === CART_STATUS_ON_HOLD;
    const isRejected = cart?.status === CART_STATUS_REJECTED;
    if (!isOnHold && !isRejected) return null;

    const reasonId = isOnHold ? cart?.holdReason : cart?.rejectReasonId;
    const description = isOnHold
      ? cart?.holdReasonDescription
      : cart?.rejectReasonDescription;
    if (!reasonId && !description) return null;

    const reasonsById = isOnHold ? holdReasonsById : rejectReasonsById;
    const reasonLabel = !reasonId
      ? "-"
      : reasonsById
        ? reasonsById[reasonId] || "-"
        : "Loading…";

    return (
      <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
        <div>
          <b>Reason:</b> {reasonLabel}
        </div>
        <div style={{ whiteSpace: "pre-wrap" }}>
          <b>Description:</b> {description || "-"}
        </div>
      </div>
    );
  };

  const handleFetchServiceProviderNameOpt = (str) => {
    cartDashboardUtils.fetchServiceProvidersByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        nameMatch: [],
        name: str,
        serviceTypeIds: [SERVICE_TYPE.HEALTH_CHECKUP],
      },
      (res) => {
        if (res && res.providers && res.providers.length > 0) {
          setServiceProviderNameOptions(res.providers.map((p) => ({ ...p })));
        } else {
          setServiceProviderNameOptions([]);
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const handlePrevNextAppoint = (arg) => {
    setOnlyPageChange(true);
    if (arg) {
      setPageNum((prevPage) => prevPage + 1);
    } else {
      if (pageNum > 1) {
        setPageNum((prevPage) => (prevPage > 1 ? prevPage - 1 : 1));
      }
    }
  };

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        createdBy: createdByFilterValue.map((e) => e.value),
      });
      setPageNum(1);
    }
  }, [createdByFilterValue]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        status: statusFilterValue.map((e) => e.value),
      });
      setPageNum(1);
    }
  }, [statusFilterValue]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      const ids = filterServiceProviderNameOptions.map((e) => e.id);
      const next = { ...filterObj, pageNum: 1 };
      if (serviceProviderFilterMode === "exclude") {
        next.ignoreServiceProviderIds = ids;
        delete next.serviceProviderIds;
      } else {
        next.serviceProviderIds = ids;
        delete next.ignoreServiceProviderIds;
      }
      setFilterObj(next);
      setPageNum(1);
    }
  }, [filterServiceProviderNameOptions, serviceProviderFilterMode]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        mode: filterModesOptions,
      });
      setPageNum(1);
    }
  }, [filterModesOptions]);

  const onRefresh = () => {
    handleGetAllCarts();
  };

  // User type filter: an empty selection drops profileTypes from the request
  // rather than sending an empty list.
  const applyProfileTypesFilter = (profileTypes) => {
    const nextFilter = { ...filterObj, pageNum: 1 };
    if (profileTypes.length > 0) {
      nextFilter.profileTypes = profileTypes;
    } else {
      delete nextFilter.profileTypes;
    }
    setFilterObj(nextFilter);
    setPageNum(1);
    setOpenFilter(0);
    setOpenBackdrop(false);
  };

  const areFiltersApplied = () => {
    if (
      filterObj?.pendingVerificationAt?.from != null ||
      filterObj?.pendingVerificationAt?.to != null ||
      filterObj?.requestedAppointmentDate?.from != null ||
      filterObj?.requestedAppointmentDate?.to != null ||
      filterObj?.cartId > 0 ||
      filterObj?.patientId > 0 ||
      filterObj?.serviceProviderIds?.length > 0 ||
      filterObj?.ignoreServiceProviderIds?.length > 0 ||
      filterObj?.appointmentId > 0 ||
      filterObj?.status?.length > 0 ||
      filterObj?.mode?.length > 0 ||
      filterObj?.profileTypes?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const resetFilters = () => {
    let resetFilterObj = filterObj;
    delete resetFilterObj.cartId;
    delete resetFilterObj.patientId;
    delete resetFilterObj.serviceProviderIds;
    delete resetFilterObj.ignoreServiceProviderIds;
    delete resetFilterObj.appointmentId;
    delete resetFilterObj.pendingVerificationAt;
    delete resetFilterObj.requestedAppointmentDate;
    delete resetFilterObj.status;
    delete resetFilterObj.mode;
    delete resetFilterObj.profileTypes;

    setFilterObj({
      ...resetFilterObj,
      pageNum: 1,
    });
    setPageNum(1);
    setOpenFilter(0);
    setOpenBackdrop(false);
  };
  useEffect(() => {
    if (removeFilters === true) {
      setCreatedByFilterValue([]);
      setStatusFilterValue([]);
      setFilterServiceProviderNameOptions([]);
      setServiceProviderFilterMode("include");
      setFilterModesOptions([]);
      setCartIdFilterText("");
      setPatientIdFilterText("");
      setAptIdFilterText("");
      setReqApptDateFrom(null);
      setReqApptDateTo(null);

      resetFilters();
    }
  }, [removeFilters]);
  useEffect(() => {
    if (componentMounted) {
      onRefresh();
    }
  }, [props.dashboardKeyReload]);

  const TableRow = ({ label, value }) => (
    <tr
      style={{
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <td
        style={{
          padding: "10px 12px",
          fontWeight: 600,
          width: "180px",
          background: "#fafafa",
        }}
      >
        {label}:
      </td>

      <td
        style={{
          padding: "10px 12px",
        }}
      >
        {value || "-"}
      </td>
    </tr>
  );

  const capitalizeFirst = (str) =>
    typeof str === "string" && str.length > 0
      ? str.charAt(0).toUpperCase() + str.slice(1)
      : str;

  const openStatusMenu = (event, cart) => {
    setStatusMenuAnchor(event.currentTarget);
    setStatusMenuCart(cart);
  };
  const closeStatusMenu = () => {
    setStatusMenuAnchor(null);
    setStatusMenuCart(null);
  };

  // Resume an ON_HOLD cart back to PENDING_REVIEW directly from the dashboard.
  // Direct POST — no extra confirmation dialog — so reviewers can quickly
  // re-queue carts while scanning the list. Refreshes the list on success.
  const handleResumeFromDashboard = (cartId) => {
    if (resumingCartId != null) return;
    setResumingCartId(cartId);
    closeStatusMenu();
    cartDashboardUtils.resumeCart(
      cartId,
      () => {
        setResumingCartId(null);
        handleGetAllCarts();
      },
      (err) => {
        setResumingCartId(null);
        EventService.emit("showError", {
          message: `Failed to resume cart: ${err?.message || "Unknown error"}`,
        });
      },
    );
  };

  const handleCartIdClick = (cartId) => {
    setLoading(true);
    cartDashboardUtils.fetchCartById(
      cartId,
      (res) => {
        setLoading(false);
        if (res) {
          // Drafts never reach the dashboard, so only two modes apply:
          // PENDING_REVIEW / ON_HOLD are actively reviewable (VERIFY); every
          // other surfaced status (REJECTED / SUCCESS / PENDING_TOPUP /
          // CANCELLED) is terminal and opens read-only.
          const status = res.status;
          let mode = "VIEW-ONLY";
          if (
            status === CART_STATUS_PENDING_REVIEW ||
            status === CART_STATUS_ON_HOLD
          ) {
            mode = "VERIFY";
          }
          props.setView(1, { cartId: cartId, mode });
        } else {
          EventService.emit("showError", {
            message: "Cart not found",
          });
        }
      },
      (err) => {
        setLoading(false);
        EventService.emit("showError", {
          message: `Error fetching cart: ${err?.message || "Unknown error"}`,
        });
      },
    );
  };

  const changeScreen = (opt, ele) => {
    if (opt === 1) {
      props.setView(1, null);
    }
    if (opt === 2) {
      props.setView(2, {
        appId: ele.appointmentId,
      });
    }
  };

  // The filters bar is sticky with z-index 100. The react-md dialogs
  // (mark-on-hold / reject / cart-rejected) render their dim overlay at
  // z-index 20, so without this the sticky header would stay bright and
  // clickable above an open dialog's backdrop. While any dialog is open we
  // drop the header beneath the overlay and make it non-interactive.
  const isAnyDialogOpen =
    holdDialogForCart != null ||
    rejectDialogForCart != null ||
    rejectedCartForDialog != null ||
    razorPayDetails != null ||
    refundFailedDetails != null ||
    refundReasonDetails != null;

  return (
    <div className="cart-verify-dashboard">
      <div className="cart-verify__container">
        <div className="cart-verify__header">
          <div
            className="cart-verify__back-btn"
            onClick={() => {
              helper.navigateTo(props, "/");
            }}
          >
            <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
          </div>
          <h1 className="cart-verify__title">Cart verification dashboard</h1>
          <RefreshButton onRefresh={onRefresh} loading={loading} />
          <div className="cart-verify__header-actions"></div>
          <Button
            id="add_new_button"
            className={"zy-btn-orange-1"}
            style={{ marginRight: "10px" }}
            onClick={() => {
              changeScreen(1, null);
            }}
          >
            Add new
          </Button>
        </div>
        {/* ________________ */}

        <div
          className="cart-verify__filters"
          style={
            isAnyDialogOpen ? { zIndex: 0, pointerEvents: "none" } : undefined
          }
        >
          <div className="cart-verify__filters-grid">
            <div className="cart-verify__filter-col">
              <p>
                User <br /> type
              </p>
              <img
                src={
                  filterObj?.profileTypes?.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                alt="Filter by user type"
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(12);
                }}
              />
              {openFilter === 12 && (
                <UserTypeFilter
                  selected={filterObj?.profileTypes ?? []}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onApply={applyProfileTypesFilter}
                />
              )}
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Cart <br /> ID
              </p>
              <img
                src={filterObj?.cartId > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(20);
                }}
              />
              {openFilter === 20 && (
                <div className="cart-verify__filter-popup--left">
                  <TextField
                    id="cart-verify-filter-cart-id"
                    className="cart-verify__filter-input"
                    placeholder="Cart ID"
                    value={cartIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/[^0-9]/g, "");
                      if (inputValue.length > 30) {
                        inputValue = inputValue.slice(0, 30);
                      }
                      setCartIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 30,
                    }}
                    InputProps={{
                      endAdornment: cartIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setCartIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.cartId;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (cartIdFilterText.trim()) {
                        const cartIdNum = parseInt(cartIdFilterText.trim(), 10);

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          cartId: cartIdNum,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Appointment <br /> ID
              </p>
              <img
                src={filterObj?.appointmentId > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(3);
                }}
              />
              {openFilter === 3 && (
                <div className="cart-verify__filter-popup--center">
                  <TextField
                    id="appointment-dialog-client-code-filter-appointment-id"
                    className="cart-verify__filter-input"
                    placeholder="Appointment ID"
                    value={aptIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/[^0-9]/g, "");

                      if (inputValue.length > 30) {
                        inputValue = inputValue.slice(0, 30);
                      }
                      setAptIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 30,
                    }}
                    InputProps={{
                      endAdornment: aptIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setAptIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.appointmentId;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (aptIdFilterText.trim()) {
                        const appointmentIdNum = parseInt(
                          aptIdFilterText.trim(),
                          10,
                        );

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          appointmentId: appointmentIdNum,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Patient <br /> ID
              </p>
              <img
                src={filterObj?.patientId > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(5);
                }}
              />
              {openFilter === 5 && (
                <div className="cart-verify__filter-popup--center">
                  <TextField
                    id="appointment-dialog-client-code-filter-patient-id"
                    className="cart-verify__filter-input"
                    placeholder="Patient ID"
                    value={patientIdFilterText}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(
                        /[^a-zA-Z0-9-_]/g,
                        "",
                      );
                      if (inputValue.length > 30) {
                        inputValue = inputValue.slice(0, 30);
                      }
                      setPatientIdFilterText(inputValue);
                    }}
                    inputProps={{
                      maxLength: 30,
                    }}
                    InputProps={{
                      endAdornment: patientIdFilterText && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setPatientIdFilterText("");
                              let removedFilterObj = { ...filterObj };
                              delete removedFilterObj.patientId;
                              setFilterObj({
                                ...removedFilterObj,
                                pageNum: 1,
                              });
                              setPageNum(1);
                            }}
                            edge="end"
                            size="small"
                          >
                            <FontIcon>close</FontIcon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div
                    style={{ display: "flex", cursor: "pointer" }}
                    onClick={() => {
                      if (patientIdFilterText.trim()) {
                        const patientIdNum = parseInt(
                          patientIdFilterText.trim(),
                          10,
                        );

                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          patientId: patientIdNum,
                        });
                        setPageNum(1);
                      }
                    }}
                  >
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "28px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="cart-verify__filter-col">
              <p>
                Patient <br /> name
              </p>
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Creation <br /> date
              </p>
              <img
                src={
                  filterObj?.pendingVerificationAt?.from ||
                  filterObj?.pendingVerificationAt?.to
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(4);
                }}
              />
              {openFilter === 4 && (
                <div className="cart-verify__filter-popup--date">
                  <div className="cart-verify__date-range">
                    <p>From</p>
                    <TextField
                      type="date"
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setCreationDateFrom(v.target.value);
                        }
                      }}
                      // inputProps={{ max: maxDate }}
                      value={creationDateFrom}
                    ></TextField>
                  </div>
                  <div className="cart-verify__date-range">
                    <p>To</p>
                    <TextField
                      type="date"
                      defaultValue={""}
                      style={{ width: "90%" }}
                      className="dob"
                      id="dob"
                      onChange={(v) => {
                        if (v.target.value) {
                          setCreationDateTo(v.target.value);
                        }
                      }}
                      // inputProps={{ max: maxDate }}
                      value={creationDateTo}
                    ></TextField>
                  </div>
                  <Button
                    className=""
                    style={{
                      padding: "3px",
                      margin: "0px 5px",
                      backgroundColor: "#c3c3c3",
                    }}
                    onClick={() => {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        pendingVerificationAt: {
                          from: moment(creationDateFrom)
                            .utc()
                            .startOf("day")
                            .add(1, "day")
                            .toISOString(),

                          to: moment(creationDateTo)
                            .utc()
                            .endOf("day")
                            .add(1, "day")
                            .toISOString(),
                        },
                      });
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    Go
                  </Button>
                  <Button
                    className=""
                    onClick={() => {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.pendingVerificationAt;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                      setCreationDateFrom(null);
                      setCreationDateTo(null);
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    <FontIcon className="">close</FontIcon>
                  </Button>
                </div>
              )}
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Requested <br /> appointment date
              </p>
              <img
                src={
                  filterObj?.requestedAppointmentDate?.from ||
                  filterObj?.requestedAppointmentDate?.to
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(6);
                }}
              />
              {openFilter === 6 && (
                <div className="cart-verify__filter-popup--date">
                  <div className="cart-verify__date-range">
                    <p>From</p>
                    <TextField
                      type="date"
                      style={{ width: "90%" }}
                      className="dob"
                      id="req-appt-from"
                      onChange={(v) => {
                        if (v.target.value) {
                          setReqApptDateFrom(v.target.value);
                        }
                      }}
                      value={reqApptDateFrom}
                    ></TextField>
                  </div>
                  <div className="cart-verify__date-range">
                    <p>To</p>
                    <TextField
                      type="date"
                      defaultValue={""}
                      style={{ width: "90%" }}
                      className="dob"
                      id="req-appt-to"
                      onChange={(v) => {
                        if (v.target.value) {
                          setReqApptDateTo(v.target.value);
                        }
                      }}
                      value={reqApptDateTo}
                    ></TextField>
                  </div>
                  <Button
                    className=""
                    style={{
                      padding: "3px",
                      margin: "0px 5px",
                      backgroundColor: "#c3c3c3",
                    }}
                    onClick={() => {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        requestedAppointmentDate: {
                          from: reqApptDateFrom
                            ? moment(reqApptDateFrom)
                                .utc()
                                .startOf("day")
                                .toISOString()
                            : null,
                          to: reqApptDateTo
                            ? moment(reqApptDateTo)
                                .utc()
                                .endOf("day")
                                .toISOString()
                            : null,
                        },
                      });
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    Go
                  </Button>
                  <Button
                    className=""
                    onClick={() => {
                      let removedFilterObj = filterObj;
                      delete removedFilterObj.requestedAppointmentDate;
                      setFilterObj({
                        ...removedFilterObj,
                        pageNum: 1,
                      });
                      setReqApptDateFrom(null);
                      setReqApptDateTo(null);
                      setPageNum(1);
                      setOpenFilter(0);
                      setOpenBackdrop(false);
                    }}
                  >
                    <FontIcon className="">close</FontIcon>
                  </Button>
                </div>
              )}
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Requested <br /> time slot
              </p>
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Requested <br /> service mode
              </p>
              <img
                src={filterModesOptions.length > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(11);
                }}
              />
              {openFilter === 11 && (
                <div className="cart-verify__filter-popup--right">
                  <Autocomplete
                    multiple
                    id="cart-verify-filter-mode"
                    className="cart-verify__filter-input"
                    options={modesOptions}
                    value={filterModesOptions}
                    getOptionLabel={(option) => option || ""}
                    onChange={(e, v) => {
                      setFilterModesOptions(v || []);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={"Service mode"}
                        className="cart-verify__autocomplete-chips"
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />
                </div>
              )}
            </div>

            <div className="cart-verify__filter-col">
              <p>
                Service provider <br /> name
              </p>
              <img
                ref={serviceProviderFilterIconRef}
                src={
                  filterServiceProviderNameOptions.length > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <ColumnFilterPopover
                  anchorRef={serviceProviderFilterIconRef}
                  title="Filter by Service Provider"
                  searchPlaceholder="Search providers..."
                  loadOptions={loadServiceProviderOptions}
                  selectedIds={filterServiceProviderNameOptions.map(
                    (p) => p.id,
                  )}
                  selectedItems={filterServiceProviderNameOptions}
                  mode={serviceProviderFilterMode}
                  onApply={(ids, items, mode) => {
                    setServiceProviderFilterMode(mode);
                    setFilterServiceProviderNameOptions(
                      items.map((it) => ({ id: it.id, label: it.label })),
                    );
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                  onClose={() => {
                    setOpenFilter(0);
                    setOpenBackdrop(false);
                  }}
                />
              )}
            </div>
            <div className="cart-verify__filter-col">
              <p>
                Verification <br /> status
              </p>
              <img
                src={statusFilterValue.length > 0 ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(10);
                }}
              />
              {openFilter === 10 && (
                <div className="cart-verify__filter-popup--right">
                  <Autocomplete
                    multiple
                    id="navigo-appointment-dialog-client-code-filter"
                    className="cart-verify__filter-input"
                    options={allStatusList}
                    value={statusFilterValue} //statusFilterValue
                    onChange={(e, v) => {
                      if (v.length > 0) {
                        setStatusFilterValue(v);
                      } else {
                        setStatusFilterValue([]);
                      }
                    }}
                    getOptionLabel={(option) => {
                      return option.name;
                    }}
                    // filterOptions={(x) => x}
                    getOptionDisabled={(option) =>
                      Array.isArray(filterObj?.status) &&
                      filterObj?.status.includes(option.value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={"Type status name"}
                        className="cart-verify__autocomplete-chips"
                      />
                    )}
                  />
                </div>
              )}
            </div>
            {areFiltersApplied() && (
              <div
                onClick={() => {
                  setRemoveFilters(true);
                }}
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                }}
              >
                <FontIcon style={{ fontSize: "22px" }}>
                  highlight_remove
                </FontIcon>
              </div>
            )}
          </div>
        </div>
        <div className="cart-verify__content">
          {appointmentsList && appointmentsList.length > 0 && (
            <div className="cart-verify__pagination">
              <Button
                className="cart-verify__pagination-btn"
                onClick={() => {
                  handlePrevNextAppoint(0);
                }}
                disabled={pageNum == 1 || loading}
              >
                <FontIcon className="cart-verify__pagination-icon">
                  arrow_drop_up
                </FontIcon>
              </Button>
              <div className="cart-verify__pagination-text">
                Showing&nbsp;
                <span
                  style={{
                    color: "#ef7c01",
                  }}
                >
                  {(pageNum - 1) * pageSize + 1}&nbsp;- &nbsp;
                  {totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount}
                </span>
                <span>&nbsp;of&nbsp;</span>
                <span>{` ${totalCount}`}</span>
              </div>
              <Button
                className="cart-verify__pagination-btn"
                onClick={() => {
                  handlePrevNextAppoint(1);
                }}
                disabled={
                  loading ||
                  pageNum * pageSize > totalCount ||
                  (totalCount > pageNum * pageSize
                    ? pageNum * pageSize
                    : totalCount) == totalCount
                }
              >
                <FontIcon className="cart-verify__pagination-icon">
                  arrow_drop_down
                </FontIcon>
              </Button>
            </div>
          )}
          {loading == false && (
            <div className="cart-verify__list">
              {appointmentsList &&
                appointmentsList.map((ele) => {
                  // Prescription-only carts (created by just uploading a
                  // prescription) have no service picked yet: serviceProviderId
                  // is 0, mode is "", and the slot date/time are the zero date
                  // (year 0001) / 0. Treat those as "not requested yet" so the
                  // Service provider / Requested appointment date / time slot
                  // columns show "—" instead of 0 / 01 Jan 0001 / 00:00.
                  const hasRequestedSlot =
                    ele?.selectedSlotDate &&
                    moment(ele.selectedSlotDate).year() > 1;
                  // The patient raised this request from an address our serviceability check
                  // had rejected, and it is still waiting on a reviewer. Flag the whole row
                  // (same red as NavigoDashboard's inactive-plan rows) so it is obvious at a
                  // glance which carts need coverage sorted out before anything else.
                  //
                  // Gated on PENDING_REVIEW: the flag is never recomputed, so on a cart that
                  // has already been booked or rejected it is history, not something to act on.
                  const needsServiceabilityAttention =
                    ele?.addressNotServiceable === true &&
                    ele?.status === CART_STATUS_PENDING_REVIEW;
                  return (
                    <div
                      className="cart-verify__row"
                      key={ele.id}
                      style={{
                        backgroundColor: needsServiceabilityAttention
                          ? "#FFDEDC"
                          : "transparent",
                      }}
                    >
                      <div className={`cart-verify__cell`}>
                        {ele?.patientProfileType != null ? (
                          <Tooltip
                            title={getProfileLabel(ele.patientProfileType)}
                            placement="top"
                          >
                            <div
                              className="cart-verify__profile-icon"
                              style={{
                                backgroundColor: getProfileIconColor(
                                  ele.patientProfileType,
                                ),
                              }}
                            >
                              <span className="material-icons">person</span>
                            </div>
                          </Tooltip>
                        ) : (
                          "—"
                        )}
                      </div>
                      <div
                        className={`cart-verify__cell cart-verify__link`}
                        style={{ color: "#1a73e8", cursor: "pointer" }}
                        onClick={() => handleCartIdClick(ele.id)}
                      >
                        {ele?.id ?? "—"}
                      </div>
                      <div className={`cart-verify__cell`}>
                        {ele?.appointmentId > 0 ? (
                          <span
                            onClick={() => changeScreen(2, ele)}
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            {ele.appointmentId}
                          </span>
                        ) : (
                          "—"
                        )}
                      </div>

                      <div className={`cart-verify__cell`}>
                        {!ele?.patientId ? (
                          "—"
                        ) : (
                          /* The patient's HEALTH RECORD — bridge's phr record,
                              /patient-record/:patientId (App.js) — in the SAME
                              tab, as a router Link (Nittin, 2026-09-25). It
                              opened the legacy /patients/{id}/new-bridge screen
                              in a new one; the appointment-details screen, the
                              appointments-v2 board and the claims dashboard all
                              made this same swap. Still an <a> underneath, so it
                              can be middle-clicked or copied. */
                          <Link
                            className="cart-verify__cell cart-verify__link cart-verify__break-word"
                            to={`/patient-record/${ele.patientId}`}
                          >
                            {ele.patientId}
                          </Link>
                        )}
                      </div>

                      <div
                        className={`cart-verify__cell cart-verify__break-word`}
                      >
                        {ele?.patientName ? ele.patientName : "—"}
                      </div>
                      <div className={`cart-verify__cell`}>
                        {ele?.pendingVerificationAt
                          ? moment(ele.pendingVerificationAt).format(
                              "DD MMM YYYY hh:mm A",
                            )
                          : "—"}
                      </div>
                      <div className={`cart-verify__cell`}>
                        {hasRequestedSlot
                          ? moment(ele.selectedSlotDate).format("DD MMM YYYY")
                          : "—"}
                      </div>
                      <div className={`cart-verify__cell`}>
                        {hasRequestedSlot
                          ? intToTime(ele.selectedSlotTime)
                          : "—"}
                      </div>
                      <div className={`cart-verify__cell`}>
                        {ele?.mode ? ele.mode : "—"}
                      </div>

                      <div
                        className={`cart-verify__cell cart-verify__break-word`}
                      >
                        {formatProviderCell(ele?.serviceProviderId)}
                      </div>
                      <div className="cart-verify__status-col">
                        {(() => {
                          const statusObj = allStatusList.find(
                            (s) => s.value === ele?.status,
                          );
                          if (!statusObj)
                            return <span style={{ color: "#777" }}>—</span>;

                          // Status pill is interactive in two different ways:
                          //  - PENDING_REVIEW / ON_HOLD open a transition menu
                          //    (mark-on-hold/reject, or resume).
                          //  - REJECTED opens the read-only Cart-rejected
                          //    details dialog (reason + description).
                          // Other terminal statuses render as a plain badge.
                          const opensMenu =
                            ele?.status === CART_STATUS_PENDING_REVIEW ||
                            ele?.status === CART_STATUS_ON_HOLD;
                          const opensRejectInfo =
                            ele?.status === CART_STATUS_REJECTED;
                          const isInteractive = opensMenu || opensRejectInfo;
                          const menuOpen =
                            statusMenuCart?.id === ele.id &&
                            Boolean(statusMenuAnchor);
                          const isResumingThis = resumingCartId === ele.id;
                          // On hold / Rejected rows explain themselves on
                          // hover; every other status has nothing to show.
                          const reasonHint = renderStatusReasonHint(ele);

                          const pill = (
                            <div
                              style={{
                                backgroundColor: statusObj.colorLight,
                                color: statusObj.colorDark,
                                padding: "1px 10px",
                                borderRadius: "20px",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                                fontWeight: 700,
                                fontSize: "13px",
                                // Fits the longest label on one line ("Pending
                                // review" + its dropdown arrow, ~148px); at 124px
                                // it wrapped and doubled the row's height.
                                width: "152px",
                                whiteSpace: "nowrap",
                                marginBottom: "2px",
                                cursor: isInteractive ? "pointer" : "default",
                                justifyContent: "center",
                                opacity: isResumingThis ? 0.6 : 1,
                              }}
                              onClick={(e) => {
                                if (!isInteractive || isResumingThis) return;
                                if (opensRejectInfo) {
                                  setRejectedCartForDialog(ele);
                                  return;
                                }
                                if (menuOpen) {
                                  closeStatusMenu();
                                } else {
                                  openStatusMenu(e, ele);
                                }
                              }}
                            >
                              {statusObj.name}
                              {opensMenu && (
                                <FontIcon
                                  style={{
                                    fontSize: "18px",
                                    color: statusObj.colorDark,
                                  }}
                                >
                                  {menuOpen
                                    ? "arrow_drop_up"
                                    : "arrow_drop_down"}
                                </FontIcon>
                              )}
                              {opensRejectInfo && (
                                <FontIcon
                                  style={{
                                    fontSize: "16px",
                                    color: statusObj.colorDark,
                                  }}
                                >
                                  info
                                </FontIcon>
                              )}
                            </div>
                          );

                          if (!reasonHint) return pill;
                          return (
                            <Tooltip
                              title={reasonHint}
                              placement="top"
                              // The row line-clamp-expands on hover; the tooltip
                              // portals to <body> so it doesn't ride that resize.
                              enterDelay={200}
                            >
                              {pill}
                            </Tooltip>
                          );
                        })()}
                      </div>
                      {/* <div className={`cart-verify__cell`}>
                        {ele?.reason ? (
                          <InfoButton
                            onClick={() => setRefundReasonDetails(ele.reason)}
                          />
                        ) : (
                          ""
                        )}
                      </div> */}

                      {/* <IconButton
                        onClick={() => {}}
                        className="navigo-appoint-section-6-grid-edit-call"
                      >
                        <OptionsIcon />
                      </IconButton> */}
                    </div>
                  );
                })}
            </div>
          )}

          {loading && <GlobalSkeletonLoader />}
          {loading === false && noAppointments && (
            <div className="cart-verify__empty-state">
              <p>No cart found!</p>
            </div>
          )}
        </div>

        {openBackdrop && (
          <div
            className="cart-verify__backdrop"
            onClick={() => {
              setOpenFilter(0);
              setOpenBackdrop(false);
            }}
          ></div>
        )}

        <Menu
          id="cart-verify-status-action-menu"
          anchorEl={statusMenuAnchor}
          open={Boolean(statusMenuAnchor)}
          onClose={closeStatusMenu}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          getContentAnchorEl={null}
          PaperProps={{ style: { marginTop: 4, minWidth: 200 } }}
        >
          {statusMenuCart?.status === CART_STATUS_PENDING_REVIEW && [
            <MenuItem
              key="hold"
              onClick={() => {
                const id = statusMenuCart.id;
                closeStatusMenu();
                setHoldDialogForCart(id);
              }}
            >
              Mark on hold
            </MenuItem>,
            <MenuItem
              key="reject"
              onClick={() => {
                const id = statusMenuCart.id;
                closeStatusMenu();
                setRejectDialogForCart(id);
              }}
            >
              Reject order
            </MenuItem>,
          ]}
          {statusMenuCart?.status === CART_STATUS_ON_HOLD && (
            <MenuItem
              onClick={() => handleResumeFromDashboard(statusMenuCart.id)}
            >
              Resume (mark as pending)
            </MenuItem>
          )}
        </Menu>

        {holdDialogForCart != null && (
          <MarkOnHoldDialog
            visible={holdDialogForCart != null}
            cartId={holdDialogForCart}
            onClose={() => setHoldDialogForCart(null)}
            onSuccess={() => {
              // Close the dialog and re-fetch the list so the row updates
              // to "On hold". No success dialog on the dashboard — the
              // reviewer is mid-triage and just wants the list refreshed.
              setHoldDialogForCart(null);
              handleGetAllCarts();
            }}
          />
        )}

        {rejectDialogForCart != null && (
          <RejectOrderDialog
            visible={rejectDialogForCart != null}
            cartId={rejectDialogForCart}
            onClose={() => setRejectDialogForCart(null)}
            onSuccess={() => {
              // Same pattern as Mark on hold from the dashboard: refresh the
              // list so the row flips to "Rejected"; no success dialog here,
              // the reviewer keeps triaging.
              setRejectDialogForCart(null);
              handleGetAllCarts();
            }}
          />
        )}

        {rejectedCartForDialog && (
          <CartRejectedDialog
            visible={!!rejectedCartForDialog}
            cart={rejectedCartForDialog}
            onClose={() => setRejectedCartForDialog(null)}
            onViewCart={() => {
              // A rejected cart is terminal, so open it read-only.
              const cartId = rejectedCartForDialog.id;
              setRejectedCartForDialog(null);
              props.setView(1, { cartId, mode: "VIEW-ONLY" });
            }}
          />
        )}

        {razorPayDetails && (
          <div className="cart-verify__dialog-overlay">
            <DialogContainer
              id="razor-details-dialog"
              visible={razorPayDetails != null}
              onHide={() => {
                setRazorPayDetails(null);
              }}
              focusOnMount={false}
              autosizeContent
              width={"800px"}
              dialogStyle={{
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              <div style={{ fontFamily: "Montserrat", color: "#000" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      margin: 0,
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "600",
                    }}
                  >
                    Razor pay refund details
                  </div>
                  <FontIcon
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      color: "#777",
                    }}
                    onClick={() => {
                      setRazorPayDetails(null);
                    }}
                  >
                    close
                  </FontIcon>
                </div>

                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "12px",
                    padding: "0",
                    overflow: "hidden",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "14px",
                    }}
                  >
                    <tbody>
                      {(() => {
                        const refundFields = [
                          {
                            label: "Refund ID",
                            value: razorPayDetails?.refundId,
                          },
                          {
                            label: "Payment ID",
                            value: razorPayDetails?.paymentId,
                          },
                          {
                            label: "Order ID",
                            value: razorPayDetails?.orderId,
                          },
                          {
                            label: "Speed requested",
                            value: capitalizeFirst(
                              razorPayDetails?.speedRequested,
                            ),
                          },
                          {
                            label: "Speed processed",
                            value: capitalizeFirst(
                              razorPayDetails?.speedProcessed,
                            ),
                          },
                          {
                            label: "Amount",
                            value: razorPayDetails?.amount
                              ? formatCurrency(razorPayDetails?.amount)
                              : null,
                          },
                          {
                            label: "Failed reason",
                            value: razorPayDetails?.failedReason,
                          },
                          {
                            label: "ARN Reference number",
                            value: razorPayDetails?.acquirerData?.arn,
                          },
                          {
                            label: "RRN Reference number",
                            value: razorPayDetails?.acquirerData?.rrn,
                          },
                          {
                            label: "UTR Reference number",
                            value: razorPayDetails?.acquirerData?.utr,
                          },
                        ];

                        return refundFields
                          .filter(
                            (f) =>
                              f.value !== null &&
                              f.value !== undefined &&
                              f.value !== "",
                          )
                          .map((f) => (
                            <TableRow
                              key={f.label}
                              label={f.label}
                              value={f.value}
                            />
                          ));
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>
            </DialogContainer>
          </div>
        )}
        {refundFailedDetails && (
          <div className="cart-verify__dialog-overlay">
            <DialogContainer
              id="razor-details-dialog"
              visible={refundFailedDetails != null}
              onHide={() => {
                setRefundFailedDetails(null);
              }}
              focusOnMount={false}
              autosizeContent
              width={"800px"}
              dialogStyle={{
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              <div style={{ fontFamily: "Montserrat", color: "#000" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      margin: 0,
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "600",
                    }}
                  >
                    Refund failed
                  </div>
                  <FontIcon
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      color: "#777",
                    }}
                    onClick={() => {
                      setRefundFailedDetails(null);
                    }}
                  >
                    close
                  </FontIcon>
                </div>
                {/* Refund details */}
                <br />
                <div style={{ textAlign: "center" }}>
                  Reason:{" "}
                  {refundFailedDetails.type === 1
                    ? refundFailedDetails.data?.walletRefund?.failedReason
                    : refundFailedDetails.type === 2
                      ? refundFailedDetails.data?.externalRefund?.failedReason
                      : ""}
                </div>
                {/* <div style={{ marginTop: "25px", textAlign: "center" }}>
                  <Button
                    raised
                    style={getButtonStyle("zyOrange")}
                    onClick={() => {}}
                  >
                    Retry refund
                  </Button>
                  <Button
                    raised
                    style={getButtonStyle("zyGrey")}
                    onClick={() => {
                      setRefundFailedDetails(null);
                    }}
                  >
                    Go back
                  </Button>
                </div> */}
              </div>
            </DialogContainer>
          </div>
        )}
        {refundReasonDetails && (
          <div className="cart-verify__dialog-overlay">
            <DialogContainer
              id="reason-details-dialog"
              visible={refundReasonDetails != null}
              onHide={() => {
                setRefundReasonDetails(null);
              }}
              focusOnMount={false}
              autosizeContent
              width={"800px"}
              dialogStyle={{
                borderRadius: "10px",
                padding: "15px",
              }}
            >
              <div style={{ fontFamily: "Montserrat", color: "#000" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      margin: 0,
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "600",
                    }}
                  >
                    Refund reason
                  </div>
                  <FontIcon
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      color: "#777",
                    }}
                    onClick={() => {
                      setRefundReasonDetails(null);
                    }}
                  >
                    close
                  </FontIcon>
                </div>
                <br />
                <div style={{ textAlign: "center" }}>
                  Reason: {refundReasonDetails}
                </div>
              </div>
            </DialogContainer>
          </div>
        )}
      </div>
    </div>
  );
}

export default CartVerificationDashboard;
